<template>
  <ImageViewer v-if="imgs.length" :urlList="imgs" :index="index" />
</template>

<script>
import ImageViewer from "./image-viewer.vue";

export default {
  name: "imgView",
  components: {
    ImageViewer
  },
  data() {
    return {
      imgs: [],
      index: 0
    };
  }
};
</script>
